module.exports = __webpack_public_path__ + "static/media/photoshop.bbedb3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/photoshop.png
// module id = 2564
// module chunks = 0